import { useMutation, useQuery } from "@apollo/client";
import {
  useMyOrgInfo,
  useUserInfo,
} from "../../../../Layout/AppMain/LoginStatusContext";
import { CREATE_ACTIVITY, GET_ACTIVITY } from "../../../../queries";
import _ from "lodash";
import { Button } from "reactstrap";
import { useEffect, useState } from "react";

import ActivityContent from "./ActivityContent";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";

/**
 * 事業詳細一覧コンポーネント
 * @param {*} param0
 * @returns
 */

const CustomTable = ({ obj, userId, project_id, year }) => {
  const myOrgInfo = useMyOrgInfo();
  const myPage = myOrgInfo.id == obj.id;
  const { ability } = useUserInfo();

  // 事業詳細の取得クエリ
  const {
    loading,
    error,
    data: activityData,
    refetch,
  } = useQuery(GET_ACTIVITY, {
    variables: { projectId: project_id, year: year },
  });

  // 年度でソート
  const [isFirst, setIsFirst] = useState(true);
  useEffect(() => {
    if (isFirst === false) {
      refetch();
    } else {
      setIsFirst(false);
    }
  }, [year]);

  //   活動事業追加Mutation
  const [createAct] = useMutation(CREATE_ACTIVITY, {
    update(cache, { data: { createActivity } }) {
      const cacheId = cache.identify(createActivity.activity);
      try {
        cache.modify({
          fields: {
            allActivity(existingAct, { toReference }) {
              return [...existingAct.edges, toReference(cacheId)];
            },
          },
        });
      } catch {
        window.location.reload();
      }
    },
  });

  const [newProjectTitle, setNewProjectTitle] = useState("");
  const createActivity = async () => {
    await createAct({
      variables: {
        orgId: myOrgInfo.id,
        userId: userId,
        projectId: project_id,
        name: newProjectTitle,
        year: year,
      },
    });
    await setNewProjectTitle("");
  };

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );

  return (
    <>
      {activityData &&
        activityData.allActivity &&
        activityData.allActivity.edges &&
        activityData.allActivity.edges.map((d, index) => (
          <>
            <ActivityContent
              key={index}
              data={d}
              project_id={project_id}
              myPage={myPage}
            />
          </>
        ))}
      {myPage && ability == "can_edit" && (
        <div style={{ textAlign: "center" }} className="mb-4">
          <span class="lnr lnr-plus-circle pointer">
            <input
              className="p-2 mx-2 ema__newbiz mt-2"
              onChange={(e) => {
                setNewProjectTitle(e.target.value);
              }}
              value={newProjectTitle}
              placeholder={`事業名`}
            />{" "}
            {newProjectTitle ? (
              <Button onClick={(e) => createActivity()}>追加</Button>
            ) : (
              <Button disabled>追加</Button>
            )}
          </span>
        </div>
      )}
    </>
  );
};

export default CustomTable;
